function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M56.25 40l7.425 7.425-7.425 7.424-.707-.707 6.467-6.468H33v-1h28.51l-5.967-5.967.707-.707z",
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#FFF",
  cx: 48,
  cy: 47,
  r: 44
}));

var SvgArrowCircled = function SvgArrowCircled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9Ijk0cHgiIGhlaWdodD0iOTRweCIgdmlld0JveD0iMCAwIDk0IDk0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNTggKDg0NjYzKSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4NCiAgICA8dGl0bGU+aWNvbm9ncmFmaWEvOTR4OTQvbmV4dDwvdGl0bGU+DQogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+DQogICAgPGcgaWQ9Imljb25vZ3JhZmlhLzk0eDk0L25leHQiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPg0KICAgICAgICA8cGF0aCBkPSJNNTYuMjUsNDAgTDYzLjY3NDYyMTIsNDcuNDI0NjIxMiBMNTYuMjUsNTQuODQ5MjQyNCBMNTUuNTQyODkzMiw1NC4xNDIxMzU2IEw2Mi4wMSw0Ny42NzQgTDMzLDQ3LjY3NDYyMTIgTDMzLDQ2LjY3NDYyMTIgTDYxLjUxLDQ2LjY3NCBMNTUuNTQyODkzMiw0MC43MDcxMDY4IEw1Ni4yNSw0MCBaIiBpZD0iQ29tYmluZWQtU2hhcGUiIGZpbGw9IiNGRkZGRkYiIGZpbGwtcnVsZT0ibm9uemVybyI+PC9wYXRoPg0KICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsIiBzdHJva2U9IiNGRkZGRkYiIGN4PSI0OCIgY3k9IjQ3IiByPSI0NCI+PC9jaXJjbGU+DQogICAgPC9nPg0KPC9zdmc+";
export { SvgArrowCircled as ReactComponent };